import { render, staticRenderFns } from "./VoiceCommandItem.vue?vue&type=template&id=0d8cac5c&scoped=true&"
import script from "./VoiceCommandItem.vue?vue&type=script&lang=js&"
export * from "./VoiceCommandItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d8cac5c",
  null
  
)

export default component.exports